// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery-module--gallery--uUG8k","galleryImg":"Gallery-module--galleryImg--vOVJc"};